<template>
    <input type="hidden" :value="csrf" name="_token">
</template>

<script>
    export default {
        name: 'csrf',
        props: {
           value: ''
        },
        computed: {
            csrf(){
                return this.value || document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            }
        }
    }
</script>
